// extracted by mini-css-extract-plugin
export default {"phone":"Phone_phone__52UbV","countrySelection":"Phone_countrySelection__3bw0C","phoneInput":"Phone_phoneInput__XAN2T"};